module.exports = __webpack_public_path__ + "img/igraph-only.5a0593b7.svg";